import React from "react"
import { Route } from "react-router-dom"
import ObjectiveCard from "./ObjectiveCard"
import ObjectiveModal from "./ObjectiveModal"

const ObjectivesList = props => {
  const { campaign, currencyLabel, objectives, onUnselectObject, selected } = props

  return (
    <div className="objectives-cards-container">
      {objectives.map(o => (
        <ObjectiveCard
          key={o.id}
          objective={o}
          campaign={campaign}
          currencyLabel={currencyLabel}
        />
      ))}
      <Route path="/objectives/:id">
        {selected && (
          <ObjectiveModal
            selected={selected}
            onUnselectObject={onUnselectObject}
            currencyLabel={currencyLabel}
          />
        )}
      </Route>
    </div>
  )
}

export default ObjectivesList